import { InvalidAmountError } from './errors.js';
/** Floor division that is correct for negative numerators, unlike bigint `/`. */
export function divideFloor(numerator, denominator) {
    if (denominator === 0n) {
        throw new InvalidAmountError('Division by zero');
    }
    const quotient = numerator / denominator;
    const remainder = numerator % denominator;
    // bigint division truncates toward zero, so a negative result with a
    // remainder is one step above the true floor.
    if (remainder !== 0n && numerator < 0n !== denominator < 0n) {
        return quotient - 1n;
    }
    return quotient;
}
/** Ceiling division, correct for negative numerators. */
export function divideCeil(numerator, denominator) {
    if (denominator === 0n) {
        throw new InvalidAmountError('Division by zero');
    }
    const quotient = numerator / denominator;
    const remainder = numerator % denominator;
    if (remainder !== 0n && numerator < 0n === denominator < 0n) {
        return quotient + 1n;
    }
    return quotient;
}
export function divide(numerator, denominator, rounding) {
    return rounding === 'floor'
        ? divideFloor(numerator, denominator)
        : divideCeil(numerator, denominator);
}
//# sourceMappingURL=rounding.js.map